import { Find_Test_Accounts } from "@/api/hasura/generated/graphql"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { ITestAccount } from "./testAccount.types"
import { TestAccount } from "./testAccount"
import { DeepPartial } from "@/types/helpers"
import { formatDateSlashed } from "@/helpers/dateHelper"
import dayjs from "dayjs"

type TestAccountRaw = DeepPartial<Find_Test_Accounts>

export const TestAccountParser: IParser<ITestAccount, TestAccountRaw> = {
  toDomain: (data: Find_Test_Accounts) => {
    try {
      return new TestAccount(
        data.account_num ?? undefined,
        data.billing_acc_id ?? undefined,
        data.fuel_type ?? undefined,
        data.latest_status ?? undefined,
        data.inside_renewal_window ?? undefined,
        data.is_active_agreement ?? undefined,
        data.multi_meterpoints ?? undefined,
        data.is_seasonal ?? undefined,
        data.to_date ? formatDateSlashed(dayjs(data.to_date)) : undefined,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
